import type { ReactNode } from "react";
import { IconChevronRight } from "@tabler/icons-react";
import { Text } from "../../../../components/common/typography";
import { Chip } from "../../../../components/common/chip";
import { toReadableDate } from "../../../../utils/date";
import type { AdminUserListItem } from "../../hooks/useAdminUsers";

/** Phone-only stacked list of users; desktop keeps the SimpleTable. */
export function AdminUsersMobileList({
  users,
  onSelect,
  footer,
}: {
  users: AdminUserListItem[];
  onSelect: (user: AdminUserListItem) => void;
  footer?: ReactNode;
}) {
  return (
    <div className="overflow-hidden rounded-xl border border-borderDefault bg-bgWhite md:hidden">
      {users.map((u, i) => (
        <button
          key={u.id}
          type="button"
          onClick={() => onSelect(u)}
          className={`flex w-full items-center gap-3 px-4 py-4 text-left transition-colors hover:bg-bgLight ${
            i > 0 ? "border-t border-borderDefault" : ""
          }`}
        >
          <div className="flex min-w-0 flex-1 flex-col gap-2">
            <div className="flex min-w-0 flex-col gap-0.5">
              <Text variant="bodyBold" tone="dark" className="truncate">{u.name}</Text>
              {u.email && <Text variant="bodySm" tone="muted" className="truncate">{u.email}</Text>}
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {u.role === "admin" ? (
                <Chip variant="underReview">Admin</Chip>
              ) : (
                <Chip variant="tertiary">User</Chip>
              )}
              {u.isActive ? (
                <Chip variant="approved">Active</Chip>
              ) : (
                <Chip variant="rejected">Inactive</Chip>
              )}
            </div>
            <Text variant="bodySm" tone="body">
              {u.phoneNumber || "—"} · Created {toReadableDate(u.createdAt)}
            </Text>
          </div>
          <IconChevronRight size={18} className="shrink-0 text-textMuted" />
        </button>
      ))}
      {footer && <div className="border-t border-borderDefault px-4 py-4">{footer}</div>}
    </div>
  );
}
